import { FC, ReactNode } from 'react';

import { EmptyNavbar } from './EmptyNavbar/EmptyNavbar';

type Props = {
    customContent?: ReactNode;
};

export const EmptyNavigation: FC<Props> = ({ customContent }) => {
    return <EmptyNavbar customContent={customContent} />;
};
